import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Header' },
    { value: 2, label: 'Content' },
    { value: 3, label: 'Detail' },
    { value: 4, label: 'Attendance' },
    { value: 5, label: 'Assessment' },
    { value: 6, label: 'Information Page' },
    { value: 7, label: 'Principal Comment' },
  ],
});
